import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChatAvatarComponent } from './chat-avatar/chat-avatar.component'
import { ChatWidgetComponent } from './chat-widget/chat-widget.component'
import { ChatInputComponent } from './chat-input/chat-input.component'
import { MaterialIcon } from 'material-icons'
import { PickerModule } from '@ctrl/ngx-emoji-mart'
import { AvatarModule } from 'ngx-avatar';
import { ChatAudioComponent } from './chat-audio/chat-audio.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatExportComponent } from './chat-export/chat-export.component'

@NgModule({
    imports: [CommonModule, PickerModule, AvatarModule,MatIconModule,MatButtonModule,MatTooltipModule],
    declarations: [ChatAvatarComponent, ChatWidgetComponent, ChatInputComponent, ChatAudioComponent, ChatExportComponent],
    exports: [ChatWidgetComponent]
})
export class ChatModule {}
